import React from 'react';
import { arrayOf, string } from 'prop-types';
import { highlightParts } from '../helpers/ticketSearch';

const HighlightedText = ({ text = '', terms = [] }) => (
  <span>
    {highlightParts(text, terms).map((part, index) => (
      part.match
        // eslint-disable-next-line react/no-array-index-key
        ? <mark key={index} className="tickets-index-page__search-match">{part.text}</mark>
        : part.text
    ))}
  </span>
);

HighlightedText.propTypes = {
  text: string,
  terms: arrayOf(string),
};

export default HighlightedText;
